<div class="teaser no-padding pointer">
  <div class="body">
    <div class="info-dark">
      <div class="d-flex align-items-center justify-content-end pb-1">
        <span
          class="red-dot me-1"
          *ngIf="isRecent"
        ></span>
        <span>{{ offer?.createdAt | baseRelativeDate }}</span>
      </div>
    </div>
    <div class="personal">
      <base-avatar
        [image]="offer?.anonymous ? '' : offer?.profile?.avatar ?? ''"
        [size]="BaseAvatarSize.xlarge"
      ></base-avatar>
      <div class="info">
        <h6
          class="mb-1"
          *ngIf="offer?.anonymous"
        >
          {{ offer?.profile?.firstName | baseAnonymizeFullName: offer?.profile?.lastName }}
        </h6>
        <h6
          class="mb-1"
          *ngIf="!offer?.anonymous"
        >
          {{ offer?.profile?.firstName }} {{ offer?.profile?.lastName }}
        </h6>
        <div>{{ offer?.pspBranch?.name }} {{ offer?.pspBranch?.businessAddress?.city }}</div>
        <div class="info-dark">
          <span *ngIf="offer?.anonymous">{{ 'placeholders.anonymised' | translate }} | </span
          >{{ 'inquiry.offeredFrom' | translate }} {{ offer?.createdAt | baseFormatDate }}
        </div>
        <div class="d-flex flex-nowrap gap-2 align-items-center">
          <h6
            class="mt-1 me-2 mb-0"
            *ngIf="offer?.hourlyRate as hourlyRate"
          >
            {{ hourlyRate | baseFormatPrice }} €
          </h6>
          <i
            (click)="openRequirementsModal($event)"
            class="fa-solid mt-1 mb-0 font-size-lg pointer"
            [ngClass]="allRequirementsFulfilled ? 'fa-check text-primary' : 'fa-xmark text-light-gray'"
            [ngbTooltip]="
              allRequirementsFulfilled
                ? ('inquiry.allRequirementsFulfilled' | translate)
                : ('inquiry.notAllRequirementsFulfilled' | translate)
            "
          ></i>
          <i
            (click)="openNoteFromProviderModal($event)"
            class="mt-1 mb-0 requirements-status pointer"
            [ngClass]="offer?.note ? 'fa-solid fa-message text-primary' : 'fa-regular fa-message-slash text-light-gray'"
            [ngbTooltip]="
              offer?.note ? ('tooltip.remarkFromProvider' | translate) : ('tooltip.noRemarksFromProvider' | translate)
            "
          ></i>
          <i
            class="fa-solid mt-1 mb-0 requirements-status fa-building"
            *ngIf="!offer?.anonymous"
            [ngClass]="offer?.profile?.experience ? 'text-primary' : 'text-light-gray'"
            [ngbTooltip]="
              offer?.profile?.experience
                ? ('tooltip.experienceInCompany' | translate)
                : ('tooltip.noExperienceInCompany' | translate)
            "
          ></i>
          <base-izs-rating
            [color]="offer?.pspBranch?.izsStatus"
            [isSmallLogo]="true"
            (click)="openIzsInfoModal($event)"
          ></base-izs-rating>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <i class="fa-solid fa-building me-3"></i>
    <div class="info">
      <div class="main-qualification-text fw-medium">{{ offer?.mainQualification?.name }}</div>
      <div>{{ offer?.department?.name }}</div>
      <div class="info-dark">{{ offer?.startDate | baseFormatDate }} - {{ offer?.endDate | baseFormatDate }}</div>
    </div>
  </div>
</div>

<ng-template #requirementsPopup>
  <base-inquiry-requirements-modal
    [inquiryRequirements]="offerInquiryRequirements"
    [candidateRequirements]="offerCandidateRequirements"
  ></base-inquiry-requirements-modal>
</ng-template>
